import axios from "axios";
import { Store } from "redux";
import { State } from "./store";
import { setError } from "./store/error/actions";

const API_URL = ""; //process.env.REACT_APP_PIX_API_URL;

const setUpInterceptors = (store: Store<State, any>) => {
	axios.interceptors.request.use(
		(request) => {
			const idempotencyKey = "asdadsadsad"; // store?.getState()?.payment?.idempotencyKey;

			// if (
			//   !(
			//     (request?.url === API_URL + "/api/users/authorize" ||
			//       request?.url === API_URL + "/api/users") &&
			//     request.method?.toUpperCase() === "POST"
			//   )
			// ) {
			//   const token = localStorage.getItem("token");
			//   request.headers["Authorization"] = `Bearer ${token}`;
			// }
			request.headers["Content-Type"] = "application/json";

			// if (idempotencyKey) {
			//   request.headers["x-idempotency-key"] = idempotencyKey;
			// }

			return request;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response?.status === 403) {
				localStorage.removeItem("token");
				// store.dispatch(signOut());
			} else {
				store.dispatch(
					setError(error.response?.data?.detailsObject?.body?.message)
				);
			}

			return Promise.reject(error);
		}
	);
};

export default setUpInterceptors;
